export const SET_BOARDING_SHEET = "@@app/SET_BOARDING_SHEET";
